module.exports = __webpack_public_path__ + "img/crayons.49b65e11.jpg";